
import CartLineItem from '~/components/shop/CartLineItem.vue'
import CheckoutButton from '~/components/shop/CheckoutButton.vue'
import CountrySelector from '~/components/shop/CountrySelector.vue'
import CustomerTypeSelector from '~/components/shop/CustomerTypeSelector.vue'
import CartFaq from '~/components/shop/CartFaq.vue'
import RelatedProducts from '~/components/shop/RelatedProducts.vue'
import KlarnaWidget from '~/components/shop/KlarnaWidget.vue'
import PaypalWidget from '~/components/shop/PaypalWidget.vue'
import PrismicData from '~/assets/js/prismic-controller.js'
export default {
  name: 'Cart',
  nuxtI18n: {
    paths: {
      en: '/cart',
      it: '/carrello',
      de: '/cart',
    },
  },
  components: { CartLineItem, CheckoutButton, CountrySelector, CustomerTypeSelector, CartFaq, RelatedProducts, KlarnaWidget, PaypalWidget
  },
  data() {
    return {
      couponCode: '',
      isLoading: false,
      isLoadingItem: false,
      notes: '',
      privacyAccepted: false,
      couponCodeError: false,
      couponToggle: false
    }
  },
  head() {
    return PrismicData.seo(this.$nuxtI18nHead({ addSeoAttributes: true }), this.$t('shop.cart.seo'), this.$route.path, this.$i18n.locale, this.$route.path, true)
  },
  computed: {
    order(){
      return JSON.parse(JSON.stringify(this.$store.getters.order))
    },
    lineItems(){
      return this.order?.line_items?.filter(i => i.item_type === 'skus' || i.item_type === 'bundles')
    },
    lineItemsPromotions(){
      return this.order?.line_items?.filter(i => i.item_type.includes('promotion'))
    },
    lineItemsCount() {
      let count = 0
      this.lineItems?.forEach(i => { count = count + i.quantity })
      return count
    },
    couponValid(){
      return (this.order.coupon_code?.length && this.order.coupon_code === this.couponCode) || this.lineItemsPromotions?.findIndex(p => p.name === this.couponCode) >= 0
    },
    couponClass(){
      if (this.couponCode?.length) {
        return this.couponValid ? 'valid' : 'not-valid'
      } else {
        return ''
      }
    },
    country(){
      const country = this.$store.getters.country
      return country?.code
    },
    discountPercentage(){
      return Math.round((-this.order.discount_amount_float / this.order.subtotal_taxable_amount_float) * 100)
    },
    subtotal(){
      let subtotal = 0
      this.lineItems.map(i => subtotal = subtotal + (i.compare_at_amount_float * i.quantity))
      return subtotal
    },
    discountTotal(){
      return this.subtotal - this.order.total_amount_float
    },
    isIntelligenceAppliances() {
      return this.$config.intelligenceAppliancesEnabled && this.country?.code === 'GB'
    }
  },
  watch: {
    order(){
      this.checkDiscount()
    },
  },
  mounted() {
    this.checkDiscount()
    const i = setInterval(() => {
      if (this.order && this.order.line_items) {
        this.trackViewCart()
        this.trackAttribution()
        clearInterval(i)
      }
    }, 1000)
  },
  methods: {
    checkDiscount(){
      if (this.order.coupon_code) {
        this.couponCode = this.order.coupon_code 
        this.couponToggle = true
      } else { this.couponCode = '' }
    },
    async applyCoupon(couponCode){
      this.couponCodeError = false
      this.couponCode = !couponCode ? '' : this.couponCode
      let toastNotification = false
      if (couponCode) {
        toastNotification = {
          message: this.$t('shop.couponToast',{code: couponCode}),
          duration: 7000
        }
      }
      const response = await this.$store.dispatch('applyCoupon', { couponCode, toastNotification})
      response && response[0]?.status === '422' ? this.couponCodeError = true : this.couponCodeError = false
    },
    async updateOrder(attributes){
      await this.$store.dispatch('updateOrder', attributes)
    },
    trackViewCart(){
      const eventAttributes = {
        "ecommerce": {
          "currency": this.order.currency_code,
          "order_id": this.$store.getters.orderId,
          "subtotal": this.order.subtotal_amount_float,
          "value": this.order.total_amount_float,
          "discount_value": Math.abs(this.order.discount_amount_float),
          "items": this.lineItems
            .filter(item => item.item_type === 'skus' || item.item_type === 'bundles')
            .map((item) => {
              return {
                "item_id": item.bundle_code || item.sku_code,
                "item_name": item.name,
                "item_brand": "Vitesy",
                "price": item.unit_amount_float,
                "discount": Math.abs(item.discount_float) / item.quantity,
                "quantity": item.quantity,
                "item_category": item.category
              }
            })
        }
      }
      this.$gtm.push({ event: 'view_cart', ...eventAttributes })
    },
    async trackAttribution(){
      const utmParams = this.$store.state.utmParams
      const metadata = {...this.order.metadata, ...utmParams}
      this.$store.dispatch('updateOrder', { metadata })
      if (utmParams && utmParams.rfsn && utmParams.rfsn.length) {
        sendRefersionCheckoutEvent(this.order.id)
      }
    }
  }
}
